// =============================================
// FILE: src/api/downloads.js
// =============================================
import axios from 'axios';


// Si ya tienes axios configurado con baseURL y token, puedes borrar esto y usar tu instancia global.
const api = axios.create({
baseURL: '/api', // usa proxy/nginx para apuntar a tu backend; en prod el dominio será el mismo
});


api.interceptors.request.use((config) => {
const token = localStorage.getItem('token');
if (token) config.headers.Authorization = `Bearer ${token}`;
return config;
});


export const DownloadsAPI = {
listForAdmin() {
return api.get('/downloads/admin').then(r => r.data);
},
listForUser() {
return api.get('/downloads').then(r => r.data);
},
upload({ file, title, visibility, profileIds, roles }) {
const fd = new FormData();
fd.append('file', file);
if (title) fd.append('title', title);
fd.append('visibility', visibility);
if (visibility === 'PROFILE') fd.append('profileIds', JSON.stringify(profileIds || []));
if (visibility === 'ROLE') fd.append('roles', JSON.stringify(roles || []));
return api.post('/downloads', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
.then(r => r.data);
},
remove(id) {
return api.delete(`/downloads/${id}`).then(r => r.data);
},
update(id, payload) {
return api.patch(`/downloads/${id}`, payload).then(r => r.data);
},
// descarga: usa directamente <a href={`/api/downloads/${id}/file`}>Descargar</a>
};